import { site } from "@/content/liane-site.ar";
import { useReveal } from "@/hooks/use-reveal";

export function HowToOrder() {
  const reveal = useReveal<HTMLDivElement>();

  return (
    <section id="how" className="py-16 lg:py-24">
      <div ref={reveal.ref} className={`container-liane ${reveal.className}`}>
        <h2 className="text-center text-2xl font-bold text-l-primary sm:text-3xl lg:text-4xl">
          {site.how.title}
        </h2>

        <ol className="mt-10 grid gap-5 lg:grid-cols-3">
          {site.how.steps.map((step, i) => (
            <li
              key={step.title}
              className="rounded-3xl border border-l-border bg-l-card p-7 text-start shadow-l-soft"
            >
              <span className="grid size-11 place-items-center rounded-full bg-l-primary font-l-display text-base font-bold text-l-primary-foreground">
                {i + 1}
              </span>
              <h3 className="mt-5 text-lg font-bold text-l-primary">{step.title}</h3>
              <p className="mt-2 text-sm leading-7 text-l-muted-foreground sm:text-base">
                {step.text}
              </p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
